import React from 'react'
import relationshipsTwoAnimation from "assets/animation/relationships-two-a-animation.json";
import Lottie from "lottie-react";
import StyledAnimationWrapper from "components/styled/AnimationWrapper.styled";
import StyledBackgroundWrapper from "components/styled/BackgroundWrapper.styled";


const SvgRelationshipTwoA = () => {
  return (
    <StyledBackgroundWrapper>
    <StyledAnimationWrapper top="0" left="23%" width="40%">
      <Lottie animationData={relationshipsTwoAnimation} loop={true} autoPlay={true} />
    </StyledAnimationWrapper>
    <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 962 1189.45"
  >
    <defs>
      <pattern
        id="SVGID_1_"
        data-name="SVGID 1"
        width={131}
        height={104}
        patternTransform="translate(-1886 15408)"
        patternUnits="userSpaceOnUse"
      >
        <path className="cls-1" d="M0 0h131v104H0z" />
        <path className="cls-1" d="M0 0h131v104H0z" />
        <path className="cls-1" d="M0 0h131v104H0z" />
        <path
          style={{
            fill: "#f2f0e6",
          }}
          d="M0 0h131v104H0z"
        />
      </pattern>
      <pattern
        id="SVGID_4_"
        data-name="SVGID 4"
        width={131}
        height={104}
        patternTransform="matrix(3.35 0 0 3.35 10181.23 36638.14)"
        patternUnits="userSpaceOnUse"
      >
        <path className="cls-1" d="M0 0h131v104H0z" />
        <path className="cls-1" d="M0 0h131v104H0z" />
        <path className="cls-1" d="M0 0h131v104H0z" />
        <path
          style={{
            fill: "#13a89e",
          }}
          d="M0 0h131v104H0z"
        />
      </pattern>
      <style>
        {
          ".cls-1,.cls-35,.cls-36,.cls-39,.cls-44,.cls-50,.cls-51,.cls-56{fill:none}.cls-5{fill:#c3ddd9}.cls-35,.cls-36,.cls-50,.cls-56{stroke-linecap:round;stroke-linejoin:round}.cls-51,.cls-56{stroke-width:2px}.cls-8{fill:#ad6b55}.cls-9{fill:#e8a18e}.cls-11{fill:#133f8e}.cls-12{fill:#dd8172}.cls-12,.cls-36,.cls-41{opacity:.2}.cls-12,.cls-31,.cls-33,.cls-35,.cls-36,.cls-41,.cls-46,.cls-50{isolation:isolate}.cls-13{fill:url(#SVGID_1_)}.cls-14{fill:#ddcdc5}.cls-15{fill:#fd9e7f}.cls-16{fill:#242730}.cls-19{fill:#a32b28}.cls-20{fill:#9c5844}.cls-21,.cls-33{fill:#fff}.cls-22{fill:#a02410}.cls-23{fill:#2e2122}.cls-24{fill:#824237}.cls-25{fill:#382632}.cls-33,.cls-35,.cls-50{opacity:.5}.cls-29{fill:#844339}.cls-31{fill:#e9eef2;opacity:.28}.cls-32{fill:#893d3b}.cls-35{stroke:#9c5844}.cls-35,.cls-50{stroke-width:1.5px}.cls-36{stroke:#dd8172}.cls-37{opacity:.7}.cls-38{fill:#77433d}.cls-39{stroke:#ddcdc5}.cls-39,.cls-44,.cls-51{stroke-miterlimit:10}.cls-40{fill:#02594f}.cls-41{fill:#9e695c}.cls-44,.cls-56{stroke:#75d1c6}.cls-46{fill:#9e6352;opacity:.3}.cls-47{fill:#061a47}.cls-50{stroke:#9e6352}.cls-51{stroke:#0d306d}.cls-52{fill:#713a39}.cls-54{fill:#352d2d}.cls-55{fill:#393146}"
        }
      </style>
    </defs>
    <path
      d="M1 914.2s186.8-305.5 455.1-243.3c132.9 30.8 234.2-33.8 300.1-99 57.8-57 81.2-130.4 90-205.8C858.9 256.6 899.3 37.8 960 2.6V0H-2l2 874.8v41.3Z"
      transform="translate(2)"
      style={{
        fill: "#c4db7b",
      }}
      id="Layer_15"
      data-name="Layer 15"
    />
    <g id="People">
      <ellipse
        className="cls-5"
        cx={118.4}
        cy={371}
        rx={97}
        ry={347}
        transform="rotate(-3.81 119.44 340.928)"
      />
      <path
        d="M66.4 43.9s85.2 125.6 63.1 300.1a345.85 345.85 0 0 0-.6 82.6c6.8 61.9 27.6 152.6 90.4 156.3 0 0 3.7-319.5-39.8-433.5 0 0-32.8-123.3-84.1-124.6-.1 0-17.7.5-29 19.1Z"
        transform="translate(2)"
        style={{
          fill: "#aeccc6",
        }}
      />
      <path
        d="M52.3 167.7C45 178.2 12 417.5 100 648.5"
        transform="translate(2)"
        style={{
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#aeccc6",
          fill: "none",
        }}
      />
      <path
        className="cls-8"
        d="M422.7 353.5c.5 28.7-7.4 47.6-10.8 51.6-23.3 4.4-92.1-16.6-92.1-16.6s-13.7 21-12.4 21.8c65.4 23.8 123 42.5 130.7 31.4s29.1-98.1 30.9-112.1c1.5-11.9-9.8-33.8-23.8-40.6s-27 30-22.5 64.5Z"
        transform="translate(2)"
      />
      <path
        className="cls-9"
        d="M249.4 248.5s-.4 8-13.5 6.9l14.6 242.7s32.5-4.6 54.5.4l7.4-118.2V255.4s-15.9-.9-15.7-6.9Z"
        transform="translate(2)"
      />
      <path
        className="cls-9"
        d="M250.5 287.6s20.3 23.8 46.4 1.8l8.1 209s-16-7.2-60.5.4V383.6Z"
        transform="translate(2)"
      />
      <path
        d="M199 690.5c-9.1-102.6-11.4-120.3.1-166.1 0 0 18.8-24.8 32.2-30 16.4-6.4 92.3-11.8 111.7 7.6 6.5 6.5 16.8 64.1 16.8 64.1 3.1 71.4 4.3 44.5 3.1 82.4"
        transform="translate(2)"
        style={{
          fill: "#351377",
        }}
      />
      <path
        className="cls-11"
        d="M273 592.9c.7-10.4 1.3-20.9 2-31.3.3-5 .5-10.1 1-15.1s3.2-35.4 2.8-40.5c-.1-.6 1.1-.6 1.1 0 .5 5.1-2.4 35.4-2.9 40.5s-.7 10.1-1 15.1c-.7 10.4-1.3 20.9-2 31.3a.5.5 0 0 1-1 0Z"
        transform="translate(2)"
      />
      <path
        className="cls-11"
        d="M273.5 593.3c-2.8-.1-5.9-.4-8-2.6s-2.8-5.2-3.5-8.1a64.77 64.77 0 0 1-1-22.8c.1-.7 1.1-.4 1 .3a64.17 64.17 0 0 0 .6 20.5c.5 2.7 1.1 5.7 2.6 8.1 1.9 3 5 3.5 8.3 3.7a.46.46 0 1 1 0 .9Z"
        transform="translate(2)"
      />
      <path
        className="cls-9"
        d="m249 223.5.4 25c.1 5 3 15.9 24.4 15.3s22.9-9 22.9-15.3l.3-25Z"
        transform="translate(2)"
      />
      <path
        className="cls-12"
        d="M296.8 234.4c-10.8 11.9-35.1 12.7-47.8.1v-9l47.9.4Z"
        transform="translate(2)"
      />
      <path
        className="cls-9"
        d="M309.3 191c-.2 0 .5-13.5.5-13.5 2.4-23.7-17.4-35.6-36.8-35.6-17.6 0-34.2 6.7-36.4 28.1-.3 3.2-1 7.8-.7 11 0 0 1.1 8.7 1 8.7-4.2 0-8.2 4.3-7.3 8.5 1.1 5.3 4.7 8.4 8 8.2h.8c10.6 28.2 23.5 32.1 34.6 33.2 10 1 25-3 34.3-33.1h.6c4.2 0 6.9-2.9 8-7.2a6.81 6.81 0 0 0-6.6-8.3Z"
        transform="translate(2)"
      />
      <path
        className="cls-12"
        d="M312.4 196.4a2 2 0 0 0-1.2-1.5 3.4 3.4 0 0 0-1-.1 4.94 4.94 0 0 1 1.6-1.9c.4-.2 0-.8-.4-.6a5.2 5.2 0 0 0-2 2.4 6.57 6.57 0 0 0-.2 3.4c.1.4.7.2.7-.2a10.45 10.45 0 0 1 0-2.5h.7l.2.1h.1l.2.1h.1l.1.1v.1c0 .1.1.1.1.2v.1c0 .1 0 .1.1.2v.6l-.1.2v.2c0 .1-.1.1-.1.2l-.1.1v.1a.45.45 0 0 0 0 .5.45.45 0 0 0 .5 0 2.57 2.57 0 0 0 .7-1.8ZM237.2 194.1a5.66 5.66 0 0 0-1.9-2.4c-.4-.3-.7.3-.4.6a5.81 5.81 0 0 1 1.6 1.9 2.33 2.33 0 0 0-1.8.6 2 2 0 0 0-.4 1.8 3.13 3.13 0 0 0 .5 1 .45.45 0 0 0 .5 0 .45.45 0 0 0 0-.5l-.1-.1-.1-.2-.1-.1c0-.1-.1-.1-.1-.2s0-.1-.1-.2 0-.1 0-.1v-.5c0-.1.1-.2.1-.4v-.1c0-.1.1-.1.1-.2l.1-.1.1-.1.2-.1.1-.1.3-.1h.8a5.28 5.28 0 0 1 0 2.5c-.1.4.6.6.7.2a4.75 4.75 0 0 0-.1-3.1Z"
        transform="translate(2)"
      />
      <path
        className="cls-13"
        d="M256.3 362.4c3.5-88.7-18.5-109.1-18.5-109.1-8.2-3.3-13.1 2-13.1 2-17.1 4.1-37.5 10.9-48.3 19.2-28.5 21.9-44.9 108.8-27.3 134.2 9.4 13.6 21.3 17.4 39.1 12.5 0 0-.3 5-.2 11.2s-12.1 101.9-10.9 107.2c0 0-1.3-9.4 22-8 24.8 1.5 60 15 60 15M311.2 253.2c7.1-1.6 12.3 3.4 12.3 3.4 17.1 4.1 29.2 12.9 36.5 14.6 11.2 2.6 59.2 14.8 96.2 16.9 40.2 2.2 105.1 3.1 105.1 3.1 15.7 14.6 12.4 41.8 12.4 41.8-14.1 6.9-68.8 10.3-112.7 9.5a922.45 922.45 0 0 1-101-8l-3 129 10 77s-29.8-1.7-51-1c-10.7.3-26 7-26 7-.1-2.4-.6-100.2-.6-102.6 0-20.8 4.9-42.4 3.4-81.5-3.6-88.7 18.4-109.2 18.4-109.2Z"
        transform="translate(2)"
      />
      <path
        className="cls-14"
        d="M190 364a61.24 61.24 0 0 1-10.6 5.2c-3.5 1.4-7.1 2.2-10.7 3.3a28 28 0 0 0-9.3 5.4 41.49 41.49 0 0 0-7.6 7.5 18.51 18.51 0 0 0-3.7 11.1.25.25 0 0 0 .5 0c-.3-7.5 5.1-13.4 10.6-17.8a27.27 27.27 0 0 1 9.6-5.6c3.5-1.1 7-1.9 10.5-3.2a74.74 74.74 0 0 0 11-5.4c.1-.1.2-.2.1-.4s-.3-.2-.4-.1ZM181.7 272.4c1.8 11 3.6 22.1 5.3 33.1.9 5.6 1.8 11.2 2.5 16.9a109.72 109.72 0 0 1 .6 16.2c-.2 5.1-.4 10.5 2.2 15.1a.22.22 0 0 0 .4-.2c-2.5-4.3-2.4-9.3-2.2-14a120.63 120.63 0 0 0-.4-15.9c-.6-5.4-1.5-10.8-2.3-16.2s-1.8-11-2.6-16.5l-3-18.6c0-.4-.5-.3-.5.1ZM188.9 421.2c13.9-4.5 25.5-15.3 29.2-29.7 1-4 1.8-8.5.4-12.5-.1-.3-.6-.2-.5.1 1.3 3.6.7 7.8-.2 11.4a39.73 39.73 0 0 1-3.8 9.9 42 42 0 0 1-14.4 15.2 48.13 48.13 0 0 1-10.8 5c-.3.2-.2.7.1.6ZM167.5 366.7a69.41 69.41 0 0 1 19.6-3.3.2.2 0 1 0 0-.4 66.8 66.8 0 0 0-19.8 3.3c-.3 0-.1.5.2.4Z"
        transform="translate(2)"
      />
      <path
        className="cls-14"
        d="M186.9 373.7a19.65 19.65 0 0 0 8.2 10.6 23.85 23.85 0 0 0 14.7 3.5c2.4-.2 5-.7 6.5-2.7.2-.3-.2-.5-.4-.2-1.8 2.4-5.5 2.6-8.2 2.6a24 24 0 0 1-9.2-1.8 19.8 19.8 0 0 1-11-12c-.1-.1-.2-.2-.3-.1-.2-.1-.2 0-.3.1ZM359.2 272.3c-2.9 9.7-2.1 19.6-.7 29.4 1.5 10.2 2.8 20.4 3.8 30.6 0 .3.7.3.6 0-1-9.9-2.2-19.7-3.7-29.6-1.5-10.1-2.5-20.3.5-30.3.2-.3-.4-.4-.5-.1ZM383.5 287.4a69.85 69.85 0 0 0-8.3 21.1 85.69 85.69 0 0 0-1.4 11.2 54.63 54.63 0 0 1-1 6.9 18.9 18.9 0 0 0-.8 5.3.3.3 0 1 0 .6 0c-.1-3.6 1.3-7.3 1.7-10.9.4-4.1.7-8.2 1.5-12.3a66.58 66.58 0 0 1 8.2-21c.1-.2 0-.3-.2-.4a.49.49 0 0 0-.3.1Z"
        transform="translate(2)"
      />
      <path
        className="cls-15"
        d="M439.7 456c30.6 11.5 64.8 11.7 100.9 5.8-6.7-22.8-3.5-57.3 0-92.2H438.2c6 35.6 10.6 63 1.5 86.4Z"
        transform="translate(2)"
      />
      <path
        className="cls-16"
        d="M421.2 564.2c1.9-48.5 6.8-74.7 11.2-86 2.8-7.3 5.2-14.7 7.3-22.2 36.5 8.7 69.1 8 95.6-7 0 0 9.9 8.5 13.9 19.7 9.8 27.7 23.9 52.4 22.4 90.5a717.22 717.22 0 0 0 2.3 89.2c-26.8 19.7-87.9 1.2-149.6-2.5.1.1-5-33.2-3.1-81.7Z"
        transform="translate(2)"
      />
      <circle
        className="cls-15"
        cx={473.5}
        cy={440.5}
        r={1.5}
        style={{
          opacity: 0.31,
        }}
      />
      <path
        d="M506.4 380.8A38.17 38.17 0 0 0 530 372l-.4-.5c-.2.2-19.5 17.7-43.4 2.3l-.3.5a36.4 36.4 0 0 0 20.5 6.5ZM475.2 376.5a18.23 18.23 0 0 0 12-4.5l-.5-.4c-.1.1-9 9-22.9 1l-.3.5a21.87 21.87 0 0 0 11.7 3.4ZM477 484c25.3 0 64.5-28.2 64.9-28.5.1-.1.2-.3.1-.4s-.3-.2-.4-.1c-.5.3-47.6 34.3-71.5 27.5S440 459.3 440 459.2s-.2-.2-.4-.2c-.2.1-.2.2-.2.4.1.2 6.3 17 30.5 23.8a24.21 24.21 0 0 0 7.1.8Z"
        transform="translate(2)"
      />
      <path
        d="M478.9 498.9c34.6 0 66.6-36.4 66.9-36.8a.3.3 0 0 0 0-.4.3.3 0 0 0-.4 0c-.4.4-38 43.1-75.4 35.8-15.2-3-25.4-8.4-30.3-15.9-4-6.1-2.8-11.5-2.8-11.5a.52.52 0 0 0-.2-.4c-.1-.1-.3.1-.4.2a17.09 17.09 0 0 0 2.9 12c5 7.7 15.3 13.2 30.7 16.2a54.73 54.73 0 0 0 9 .8Z"
        transform="translate(2)"
      />
      <path
        style={{
          fill: "#282b34",
        }}
        d="M511.1 494.1h21.6v.4h-21.6z"
      />
      <path
        className="cls-8"
        d="M518.3 460.6a50.28 50.28 0 0 0-17.3.7c-8.8 2.1-17.9 6.4-22.7 7.5.2 0 .8 4.4 6.6 3.4s9.5-1.8 9.5-1.8l3.9 1.5c-1.8 4.1-14.4 11.1-28.9 26.6 0 .5.5 3.5 2.8 1.7s24.3-19.5 25.4-17.6c1.5 1.9-23.9 19.6-25 21.2-1.9 2.5.3 4.2 1.9 3.2s25.5-19.9 25.9-19c.6 2.1-16.9 16-19.4 17s-3.4 4.9-1.9 5.3c2.9.9 22-15.9 24.2-16.8s.2 2.2-2 4.4-10.7 8.2-11.4 9.7.1 3.1 1.4 2.5 24.9-17.8 29.8-20.7 10.9-12.5 12.4-18.5-7.1-11.5-15.2-10.3ZM464 291.5s-14.9 24.1-12.5 82.5"
        transform="translate(2)"
      />
      <path
        className="cls-8"
        d="M466 289.5s-11.9 6-12.9 40.5 5.2 1.8 5.2 1.8l14.7-46.3M578.8 353.7s-5.8-2.2-6.8 4.3l-12-4.7 9.5-13.8 11.5 12Z"
        transform="translate(2)"
      />
      <path
        className="cls-8"
        d="m552 348.5 3-51.9-4.2-6.6-4.1-1.7-26.8-11.2a4.83 4.83 0 0 1-3.5-4.7v-37.1a5 5 0 0 0-5.2-4.9H473a5 5 0 0 0-5.2 4.9v37a5 5 0 0 1-3.5 4.7l-17.6 7.4c-11.9 5-19.8 15.8-20.6 28.1v.6l-2.1 36.5 4.9 31.4 25.7.9.7-15.2 93.8-6Z"
        transform="translate(2)"
      />
      <path
        className="cls-19"
        d="M456 195.7s2.8 41.7 5.2 49c.2.8-.8 1.4-1.6 1.1l-10.7-4.4a3.58 3.58 0 0 1-2.5-3.7c.8-8.8.2-38.3 5.1-48.3Z"
        transform="translate(2)"
      />
      <path
        className="cls-20"
        d="M464.4 249.8c0 6.2 10.3 14.7 23.1 14.7s23.1-8.5 23.1-14.7-10.3-11.3-23.1-11.3-23.1 5-23.1 11.3Z"
        transform="translate(2)"
      />
      <path
        className="cls-8"
        d="M454.1 184.9c-3.5 24.9-5.7 71.2 25.3 74.6 29.2 3.3 53.8-34 54.4-63.4.6-30.1-3.5-40.4-33.3-44.6s-42.2 3.6-46.4 33.4Z"
        transform="translate(2)"
      />
      <path
        className="cls-19"
        d="M459.8 208.6a30.46 30.46 0 0 1 10.8-1.6c.7 0 1.2-1.8.2-2.1-3-.9-8 .9-9.7 1.9s-3.2 2.4-1.3 1.8ZM499.1 211a36.2 36.2 0 0 0-12.2-1.9c-.8 0-1.3-2-.2-2.3 3.5-1 9 1.1 11 2.2s3.6 2.6 1.4 2Z"
        transform="translate(2)"
      />
      <path
        className="cls-21"
        d="M479.4 240.1a9.48 9.48 0 0 1-7.4-2.8c-.1-.2-.2-.3.1-.3 2.3.2 4.6.2 6.9.2a53.11 53.11 0 0 0 6.8-1c.3 0 .3.1.2.3a8.39 8.39 0 0 1-6.6 3.6Z"
        transform="translate(2)"
      />
      <path
        className="cls-22"
        d="M454.4 170.6s-13.9-10.5-1.6-20.3 23.6-5.9 26.5 2.9-7.6 25.1-14.8 22.7-10.1-5.3-10.1-5.3Z"
        transform="translate(2)"
      />
      <path
        className="cls-19"
        d="M517.1 226.9s-2.5 18.6 4 25.6c0-.2 3.4-10 8.2-25.6s-12.2 0-12.2 0ZM524 166.1s.5-17.4 15.6-13.1 18.5 15.8 13.1 23.3-24.8 8.4-27.1 1.1-1.6-11.3-1.6-11.3ZM466.7 168.1s-2.7 16 5.2 23.6 10.6 19.2 10.6 19.2-3.5-10.5-10.8-16.3-12.3-24.5-8.3-28.5 3.3 2 3.3 2Z"
        transform="translate(2)"
      />
      <path
        className="cls-22"
        d="M509.1 201.9s1.4 64.3-2.7 86.1c.3-.8 4.7 0 4.7 0s8.9-45.5 8.1-58.7c1.5 1.7 2.4 11.5 3.8 16.1s11.9-3.9 11.9-3.9 9.5-74-21.5-88.4-43.4 6.4-43.4 6.4Z"
        transform="translate(2)"
      />
      <path
        className="cls-22"
        d="M463.9 172.1c.4.8 7.5 22.6 23.6 22.6s17.8 15.6 25.9 12 3.3-20.4-5-32.9-11-26.8-26-23.9-23.5 11.7-18.5 22.2Z"
        transform="translate(2)"
      />
      <path
        className="cls-19"
        d="M451 201.6s2-19.1 12.7-21.9c13.5-3.5 13.2-14.9 3.1-15.9s-26.3 14.8-15.8 37.8Z"
        transform="translate(2)"
      />
      <path
        className="cls-23"
        d="M486.8 218.8a2 2 0 0 0 2.8.3l.3-.3a2.71 2.71 0 0 0 0-3.4 2 2 0 0 0-2.8-.3l-.3.3a2.48 2.48 0 0 0 0 3.4ZM460.5 219.1a2.21 2.21 0 0 0 3.1.2l.2-.2a3 3 0 0 0 0-3.8 2.21 2.21 0 0 0-3.1-.2l-.2.2a2.89 2.89 0 0 0 0 3.8Z"
        transform="translate(2)"
      />
      <path
        className="cls-20"
        d="M478.5 230.1c-1.1-.1-3.4-.6-4.1-1.7a1.23 1.23 0 0 1-.2-1c.4-1.1 2.3-7.9 2.3-8s.2-.4.4-.3.4.2.3.4v.1c-.1.3-2 6.9-2.3 8a.37.37 0 0 0 .1.3c.4.6 2.3 1.2 3.5 1.3a.43.43 0 0 1 .4.4.66.66 0 0 1-.4.5Z"
        transform="translate(2)"
      />
      <path
        className="cls-8"
        d="M446 284.5s-23.1 6.5-29.3 31.2a40.36 40.36 0 0 0-1.1 9.8c.1 12.9.5 55.3.5 71.2-.1 18.8 6.8 5.7 6.8 5.7l20.1-42.7ZM642 402.5c-2.9-10.3-31.1-53.6-50.7-78.5-17.3-31.5-38.7-34-38.7-34l-.5 3.9a25.06 25.06 0 0 0-14.6 1.1c-15.3 6.2-1.7 46.6 29.3 65.7 23.5 18.4 33.2 36.7 34.1 41.9-12.7 20.5-77.8 58.8-77.8 58.8s22 7.4 23.5 7c64.9-33.8 99.1-52.8 95.4-65.9Z"
        transform="translate(2)"
      />
      <path
        className="cls-24"
        d="M282.9 188.3c-.7-1.4 0-2.1 2.1-2.6a15.15 15.15 0 0 1 6.7 0c4.5 1 6.8 4.7 5.5 4.1-2.1-1-3.9-1.6-8.5-1.7-2.4-.1-5.3 1.1-5.8.2ZM267.7 187.4c.7-1.3.1-2.1-2.1-2.7a16.8 16.8 0 0 0-6.7-.1c-4.5.9-6.8 4.7-5.5 4.1 2.1-1 3.9-1.5 8.5-1.6 2.5-.1 5.3 1.2 5.8.3Z"
        transform="translate(2)"
      />
      <path
        className="cls-25"
        d="M266.5 198.2a1.86 1.86 0 0 1-3.7-.3 1.92 1.92 0 0 1 1.7-1.7 2 2 0 0 1 2 2ZM294.6 198.7a1.86 1.86 0 0 1-3.7-.3 1.92 1.92 0 0 1 1.7-1.7 2 2 0 0 1 2 2Z"
        transform="translate(2)"
      />
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M277.2 201.9c.2 1.5.6 3 .9 4.5a11.27 11.27 0 0 1 .5 3.2 2.21 2.21 0 0 1-.6 1.9 3.61 3.61 0 0 1-2.5.6 4 4 0 0 1-2.9-2.3.38.38 0 0 1 .7-.3 3 3 0 0 0 3 1.9c.8-.1 1.5-.4 1.6-1.2a11.7 11.7 0 0 0-.4-3.2c-.4-1.6-.7-3.2-1-4.9-.1-.5.7-.7.7-.2Z"
          transform="translate(2)"
          style={{
            opacity: 0.5,
            isolation: "isolate",
            fill: "#dd8172",
          }}
        />
      </g>
      <path
        className="cls-21"
        d="m279.3 219.2-8.1-.7a.91.91 0 0 0-1 .8 1.14 1.14 0 0 0 .3.8c2 1.8 5.4 3.8 9.4.7a1 1 0 0 0 .2-1.3c-.3-.1-.5-.3-.8-.3Z"
        transform="translate(2)"
      />
      <path
        d="M329.8 158.4a10.27 10.27 0 0 0 2.5-12.1 10 10 0 0 0-6.9-5.6 8.37 8.37 0 0 0-1-5.4 8.92 8.92 0 0 0-7-4.5 6.41 6.41 0 0 0-3.1-3.9 8 8 0 0 0-5.7-.9 8.27 8.27 0 0 0-4.6-3.6 7 7 0 0 0-3.8-.2 9.13 9.13 0 0 0-3-2.5 8.32 8.32 0 0 0-5.6-.7 9 9 0 0 0-12.5-2.2 10.7 10.7 0 0 0-1.6 1.4 12.43 12.43 0 0 0-12.5-.4 1.79 1.79 0 0 0-.7.5 13.89 13.89 0 0 0-4.3 2.8 18.32 18.32 0 0 0-7.7-1.2c-2.5.2-4.9.9-6.3 2.8a5.7 5.7 0 0 0-1.3.1 9.13 9.13 0 0 0-4.2 1.7 10.16 10.16 0 0 0-4.5 8.7 9.86 9.86 0 0 0 .3 2.4 12.34 12.34 0 0 0-2.9 2.2 11.88 11.88 0 0 0-3 7.8 10.56 10.56 0 0 0-6.8 6.7 11.56 11.56 0 0 0 1 9.6c-.1.2-.3.5-.4.7a7.17 7.17 0 0 0-.2 5.2c.5 1.7 1.8 2.7 2.5 4.2v.1a9.49 9.49 0 0 0 1.7 10.4 5.67 5.67 0 0 0 1.8 1.2 9.17 9.17 0 0 0 2.7 4.9c3.3 2.9 8.7 1.6 11-1.9a8.15 8.15 0 0 0 .9-7.1 13.07 13.07 0 0 0 4.4-5.2 11.08 11.08 0 0 0 .8-3.6 16.2 16.2 0 0 0 7.2-5.4 11.66 11.66 0 0 0 6.9.6 12.54 12.54 0 0 0 4.2-2 11.69 11.69 0 0 0 4.5 6.2c3.3 2.2 7.4 2 10.9.3a9.5 9.5 0 0 0 1.7-1 16.32 16.32 0 0 0 1.2 5.3 12.32 12.32 0 0 0 13.8 7 12.52 12.52 0 0 0 5.6 9.8 10.87 10.87 0 0 0 9.6 1 7.61 7.61 0 0 0 2.8 1.5 11.06 11.06 0 0 0 13.5-13.2c5.5-6.6 4.5-16.8-1.9-22.5Zm-97.4 7-.1-.1c.1-.1.1 0 .1.1Z"
        transform="translate(2)"
        style={{
          fill: "#8f493b",
        }}
      />
      <path
        className="cls-29"
        d="M267.4 162a21 21 0 0 1 .3-25.2c.4-.5-.5-1.1-.9-.5a21.9 21.9 0 0 0-.3 26.2c.4.6 1.3 0 .9-.5ZM285.9 167.2c.1-3.9 3.8-6.3 6.8-8.1a.49.49 0 0 0 .1-.7.48.48 0 0 0-.6-.2c-3.4 2-7.2 4.7-7.3 9.1 0 .6 1 .6 1-.1ZM316.2 192a11.86 11.86 0 0 0 3.8-11.9.52.52 0 0 0-.7-.3.42.42 0 0 0-.3.6 11.18 11.18 0 0 1-3.5 10.9c-.5.4.2 1.2.7.7ZM231.8 146a10 10 0 0 1 12.3 7 6.45 6.45 0 0 1 .3 2c.1.7 1.1.7 1.1 0a11.23 11.23 0 0 0-11.8-10.4 8.51 8.51 0 0 0-2.2.4.52.52 0 0 0-.3.7.49.49 0 0 0 .6.3ZM322.9 140.4a10.15 10.15 0 0 0-8.2 7.8c-.1.7.9.9 1 .3a9.19 9.19 0 0 1 7.5-7 .62.62 0 0 0 .4-.6.64.64 0 0 0-.7-.5ZM244.5 177.6a10.35 10.35 0 0 0-9.9-7.6.5.5 0 1 0 0 1 9.42 9.42 0 0 1 8.9 6.9.44.44 0 0 0 .7.2.91.91 0 0 0 .3-.5ZM301.3 182.3c4.3-.9 8.9-3 10.3-7.5.2-.6-.8-.9-1-.3-1.3 4.1-5.7 6-9.6 6.8-.6.1-.3 1.1.3 1ZM278.5 119.5c5.2 1.6 7.7 7 8.4 12 .1.7 1.1.4 1-.3-.8-5.4-3.6-11-9.2-12.7-.5-.2-.8.8-.2 1Z"
        transform="translate(2)"
      />
      <path
        className="cls-16"
        d="M444.5 285.2c-3 .9-9.8 5.2-9.8 5.2 7.3 10.9 1.3 46 1.3 46.2a6.89 6.89 0 0 1-1.1 1.3c-10.7 10.5-.5 35.1-.5 35.1s9.6 36.6 8.7 51.4-3 31-3 31l-12 51 141 20-12-39s-12-23.6-12.5-51.5 5.4-78 5.4-78a80.29 80.29 0 0 1-2.7-40.4l4-28.2-10.1-4.1s.1 47.3-8.3 53.2c0 0-50.1 11-86-1.9 0 0-2.5-2.1-2.3-8.9-1.4-14.9.3-42.7.3-42.7a4 4 0 0 0-.4.3"
        transform="translate(2)"
      />
      <path
        d="m511.4 475.5-27.3 2.6a3 3 0 0 1-3.2-2.4l-10-49.1 44.4-4.2-1.2 50.2a3.09 3.09 0 0 1-2.7 2.9Z"
        transform="translate(2)"
        style={{
          fill: "#9b4d49",
        }}
      />
      <path
        className="cls-31"
        d="m476.8 432.2 7.2-.7a.82.82 0 0 1 .9.8l.7 7.5a.82.82 0 0 1-.7 1l-7.2.7a.82.82 0 0 1-.9-.8l-.7-7.5c-.2-.5.2-.9.7-1ZM493.1 463.3l5.2-5.3a.78.78 0 0 1 1.1 0l5.1 5.4a.91.91 0 0 1 0 1.2l-5.2 5.3a.78.78 0 0 1-1.1 0l-5.1-5.4a.91.91 0 0 1 0-1.2ZM497.2 438.9l4.6-5.8a.53.53 0 0 1 .8-.1l5.5 4.8a.63.63 0 0 1 .1.9l-4.6 5.8a.53.53 0 0 1-.8.1l-5.5-4.8a.63.63 0 0 1-.1-.9Z"
        transform="translate(2)"
      />
      <path
        className="cls-32"
        d="M506.9 427.8a1.42 1.42 0 0 1 1.6 1.4 1.55 1.55 0 0 1-1.3 1.7 1.48 1.48 0 0 1-1.6-1.4 1.38 1.38 0 0 1 1.3-1.7ZM507.8 455.6a1.54 1.54 0 0 1 1.6 1.4 1.62 1.62 0 0 1-1.4 1.6 1.54 1.54 0 0 1-1.6-1.4 1.62 1.62 0 0 1 1.4-1.6ZM486.5 467a1.54 1.54 0 0 1 1.6 1.4 1.62 1.62 0 0 1-1.4 1.6 1.5 1.5 0 0 1-.2-3Z"
        transform="translate(2)"
      />
      <path
        className="cls-33"
        d="m470.4 420.4 44.4-4.2a3 3 0 0 1 3.2 2.8 3 3 0 0 1-2.7 3.4l-44.3 4.2a3 3 0 0 1-3.2-2.8 3 3 0 0 1 2.6-3.4Z"
        transform="translate(2)"
      />
      <path
        className="cls-21"
        d="M490.1 387.5a1.42 1.42 0 0 1 1.5 1.2l2.6 29.4-2.7.3-2.6-29.4a1.34 1.34 0 0 1 1.2-1.5Z"
        transform="translate(2)"
      />
      <path
        className="cls-33"
        d="m486.3 397.1 8.9-.9c9.8-.9 18.5 6.6 19.4 16.8l.3 3.1-44.4 4.2-.3-3.1a18.3 18.3 0 0 1 16.1-20.1Z"
        transform="translate(2)"
      />
      <path
        className="cls-8"
        d="M551.9 465.3s-12.8 7.8-19.5 9.2-17.3-5.7-17.3-5.7-16 9.8-19.5 10.6-2.5-3.3-2.5-3.3l18-13.1s-20.8 4.5-24 5.1c-1.6.3-1.9-.7-1.9-1.9a4.05 4.05 0 0 1 2-3.3l1.7-1s-2.4 1.2-4.1-.4 1.7-4.2 3.4-4.8 17.6-7.1 17.6-7.1-5.6-3.3-10.8-1.4-7.1 4.6-10.4 4.6 2.5-6.4 13.1-10.8c4.6-1.8 16.4 3 16.4 3l9.5 1.6 23.7 1.2c6.5 5.1-1.7 11.2 4.6 17.5Z"
        transform="translate(2)"
      />
      <path className="cls-20" d="m504.8 455.8-20.7 6.5-.2-.4 20.8-6.5.1.4z" />
      <path
        d="M442.2 381.5s6.3 7.1 22.5 7.5"
        transform="translate(2)"
        style={{
          stroke: "#2b2b2b",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none",
        }}
      />
      <path
        className="cls-35"
        d="M602.9 402.7s13.6-6.2 21.4.3M412.9 406.1s7.7 4 9.4 9.7"
        transform="translate(2)"
      />
      <path
        className="cls-36"
        d="M279.1 272.1s6.2-5.7 21.5-4.1M270.7 272.1s-6.2-5.7-21.5-4.1"
        transform="translate(2)"
      />
      <path
        className="cls-35"
        d="M476.3 300.8s-1.7-7.3-22.5-4.4M494.5 300.4s1.7-6.7 22.5-4.1"
        transform="translate(2)"
      />
      <path
        className="cls-9"
        d="M551.5 285.6c1.7-1.1 7.3 1.5 7.3 1.5 4.5.1 7.7 4.3 7.7 4.3a6.87 6.87 0 0 1 5.1 3.8 9 9 0 0 1 5.6 7c3.4 13.1-15.3 32.2-28.9 29.8-1.8-.3-8.1-1.3-6.3-4.1 0 0-4.6-1-3.2-4 0 0-3.9-1.1-2.1-4.6 0 0-4-1.1-1.6-4.2 5.5-6.9 8.2-10.6 12.1-23.6 1.5-4.9 4.3-5.9 4.3-5.9Z"
        transform="translate(2)"
      />
      <g className="cls-37">
        <path
          className="cls-38"
          d="M558.3 289a117.38 117.38 0 0 1-19.6 28.3c-.3.4.3.8.6.5a121.81 121.81 0 0 0 19.7-28.5c.2-.5-.5-.7-.7-.3Z"
          transform="translate(2)"
        />
      </g>
      <g className="cls-37">
        <path
          className="cls-38"
          d="M540.2 323.7c8.9-4.2 15-12.1 20.8-19.8.3-.4-.3-.9-.6-.5-5.7 7.5-11.7 15.4-20.5 19.5a.37.37 0 0 0-.2.5c.1.3.3.4.5.3Z"
          transform="translate(2)"
        />
      </g>
      <g className="cls-37">
        <path
          className="cls-38"
          d="M545.1 328.3c7.6-3.1 12.7-9.3 17.5-15.2.2-.3-.3-.7-.6-.4-4.7 5.9-9.7 12-17.2 15-.4.2-.1.7.3.6Z"
          transform="translate(2)"
        />
      </g>
      <path
        className="cls-39"
        d="M323.6 261.7s-30.1 22.3-22.9 272.7M222.6 260.7s30.1 22.3 22.9 272.7"
        transform="translate(2)"
      />
      <path
        className="cls-5"
        d="M252.3 313.5h-45.8a1.32 1.32 0 0 0-1.3 1.3v2.6a1.32 1.32 0 0 0 1.3 1.3 1.88 1.88 0 0 1 1.9 1.8l2.4 47a2.63 2.63 0 0 0 2.6 2.5h31.9a2.56 2.56 0 0 0 2.6-2.5l2.4-47a2 2 0 0 1 1.9-1.8 1.32 1.32 0 0 0 1.3-1.3v-2.6a1.18 1.18 0 0 0-1.2-1.3Z"
        transform="translate(2)"
      />
      <path
        className="cls-40"
        d="m248.5 357.6 1.4-26.3H209l1.4 26.3ZM228.7 305.9l-2.6 1.9a3 3 0 0 1-1.6.5h-14.9a1.32 1.32 0 0 0-1.3 1.3v4h42.2v-6.9a1.32 1.32 0 0 0-1.3-1.3h-18.9a2.35 2.35 0 0 0-1.6.5Z"
        transform="translate(2)"
      />
      <path
        className="cls-9"
        d="M190.1 369.4a7.67 7.67 0 0 1 1-4.9s-1.2-4.1-.5-6.2 1.7-2.7 3.4-4c0 0-1.3-4.2-.3-6.5.9-2 3.1-2.5 5-3.8 0 0-3.7-2.3-2.4-6.1 1.1-3.1 9.6-3.4 10.2-3.4 6.8-.1 14.4 2.3 14.5 5 .1 1.9-3.5 4.7-3.5 4.7 3.7.4 6.2 1.9 6.2 3.7 0 3.7-6.2 5.9-6.2 5.9 3.4.9 7.2 3.3 7.2 5.2 0 4.4-8.7 5-8.7 5 3.4 1.5 5.2 3 5.1 5.4-.1 2-3.8 4.4-3.8 4.4a3.85 3.85 0 0 1 1.4 4.2c-1 3-11.9 5.4-19.1 2.7-1.6-.6-3.2-1.1-6-4.5-3-4.1-3.4-5.6-3.5-6.8Z"
        transform="translate(2)"
      />
      <g className="cls-37">
        <path
          className="cls-41"
          d="M199.1 344.1a9.76 9.76 0 0 1 4.4-1 33.81 33.81 0 0 1 4.5.1c3.1.3 6.1 1.2 9.2 1a.25.25 0 0 0 0-.5c-3.3.1-6.5-.9-9.8-1.1-2.8-.2-6-.3-8.6 1-.2.2.1.6.3.5Z"
          transform="translate(2)"
        />
      </g>
      <g className="cls-37">
        <path
          className="cls-41"
          d="M194.7 354.3c3.4-1.4 7.2-1.4 10.8-1.3 4 .1 7.9.4 11.9.7a.25.25 0 0 0 0-.5c-4-.4-8.1-.6-12.2-.7-3.6-.1-7.3-.1-10.6 1.3-.3.2-.2.6.1.5Z"
          transform="translate(2)"
        />
      </g>
      <g className="cls-37">
        <path
          className="cls-41"
          d="M191.8 364.7a40.7 40.7 0 0 1 6.1-.8c2 0 4.1.2 6.1.3s4-.3 6-.1a28.16 28.16 0 0 0 5.8-.2c.3 0 .2-.5-.1-.5a17.33 17.33 0 0 1-3.2.3c-1 0-1.9-.1-2.9-.1-2.1-.1-4.1.3-6.2.1a39.24 39.24 0 0 0-5.9-.2 28 28 0 0 0-5.7.8c-.4 0-.3.5 0 .4Z"
          transform="translate(2)"
        />
      </g>
      <g className="cls-37">
        <path
          className="cls-41"
          d="M217 373.5c-1.6.9-3.7.8-5.5.8-2 0-4 0-6-.1a56.29 56.29 0 0 1-5.9-.5 18.24 18.24 0 0 1-2.5-.7 4.69 4.69 0 0 1-2.4-1.5c-.2-.2-.6 0-.4.2.9 1.3 2.8 1.8 4.2 2.2a34.82 34.82 0 0 0 6.4.7c2.3.1 4.5.2 6.8.2a11.82 11.82 0 0 0 5.6-.9c.2-.1-.1-.5-.3-.4Z"
          transform="translate(2)"
        />
      </g>
    </g>
    <path
      d="M0 916.1s186.8-308.9 455.1-246.7c132.9 30.8 234.2-33.8 300.1-99 57.8-57 81.2-130.4 90-205.8C857.4 259.8 904.8 50.7 960 2.6c-48.2 29.7-104.6 145.3-118.3 233-13.5 87.1-32 173.4-89.6 240-65.7 76-166.6 151.4-298.9 115.4C186 518.5 0 874.8 0 874.8"
      transform="translate(2)"
      style={{
        fill: "#ef6043",
      }}
      id="eyes"
    />
    <path
      className="cls-9"
      d="M634.3 1118.5v-1.1c-.1-3.4-3-34.7 1-68.8l-38-3.4c3.2 37.4 6.8 65 7.1 71.9.3 8.3-8.9 20.6-15.8 30.7a47.09 47.09 0 0 0-7.5 13.5 12.91 12.91 0 0 0-.8 5.2c.7 8.9 7.9 20.5 19 22.6s25.2-5.7 29.6-14.2l.4-.6a17.79 17.79 0 0 0 1.6-6c.3-4.8-.1-9.8 1.5-15.3 4.2-15 4.1-32.6 1.9-34.5ZM716.5 1118.5v-1.1c.1-3.4 3-34.7-1-68.8l38-3.4c-3.2 37.4-6.8 65-7.1 71.9-.3 8.3 8.9 20.6 15.8 30.7a45.8 45.8 0 0 1 7.5 13.5 12.91 12.91 0 0 1 .8 5.2c-.7 8.9-7.9 20.5-19 22.6s-25.2-5.7-29.6-14.2l-.4-.6a17.79 17.79 0 0 1-1.6-6c-.3-4.8.1-9.8-1.5-15.3-4.3-15-4.1-32.6-1.9-34.5Z"
      transform="translate(2)"
    />
    <path
      d="m750 608.5 11 41c13 100.5 1.9 153.1 4.8 237.7 3.3 97.2 1.3 178.5 1.3 178.5-28.1 4.1-68.4-.7-68.4-.7.7-50.8 3-86.9 3-176.3 0-74.9-23.4-133.7-23.4-133.7-9.6 26.6-26 58.6-26.5 135.2-.7 99.4-5.4 175.4-5.4 175.4-25.1 4.9-64.4-2-64.4-2-1.4-71.8 8.3-80.3 8.3-179.7 0-60.8-9.7-135.3 11.5-250.5 0 0 2.1-19.9 2.6-25Z"
      transform="translate(2)"
      style={{
        fill: "#10a79e",
      }}
    />
    <path
      className="cls-44"
      d="M639.4 1048.9a93 93 0 0 1-22.9 2.6c-3.9-.1-7.8-.4-11.8-.7a67.68 67.68 0 0 1-11-1.5.52.52 0 0 1-.3-.7.42.42 0 0 1 .6-.3 75.14 75.14 0 0 0 11.6 1.5c3.6.3 7.2.5 10.9.6a97 97 0 0 0 22.7-2.6.56.56 0 0 1 .2 1.1ZM760.3 1048c-7.6 2.6-15.6 2.7-23.5 2.7a148.7 148.7 0 0 1-25-1.8c-.7-.1-.4-1.1.3-1a158.23 158.23 0 0 0 24.8 1.7c7.8-.1 15.7-.1 23.2-2.7a.56.56 0 0 1 .2 1.1Z"
      transform="translate(2)"
    />
    <path
      d="M754.1 625.8c2 3.5 4.5 13.1 7.4 27.8 8.4 42.5 5.5 70.2 5.5 85.9l-175.8-10.7c-.8-15.8.1-33.4 4.6-61.9 3.4-21.3 6.8-33.4 12.1-41.5Z"
      transform="translate(2)"
      style={{
        fill: "url(#SVGID_4_)",
      }}
    />
    <path
      className="cls-9"
      d="m644.7 486.9 97.1 1.4c-8.7-37.8-13.7-76.9-13.7-76.9s-7.5-3-9.2-3.9c-2.9-1.6-4.2-5.2-4.2-8.8l8.8-24.9-40.7-6.8-7.4 25.8a21.3 21.3 0 0 1-6.8 15.2 20.94 20.94 0 0 1-8.1 4.2c0-.1-1.3 19.2-15.8 74.7Z"
      transform="translate(2)"
    />
    <path
      className="cls-46"
      d="M719.2 385.9c-19.8 1.4-27.7-2.1-38.1-13.1l1.7-6 38.5 12.9Z"
      transform="translate(2)"
    />
    <path
      className="cls-47"
      d="M716.2 407.1c-30.5-.4-34.6-4.1-34.6-4.1-3.3 4.1-9.2-7.3-9.2-7.3-15.4 4.6-63.3 8.1-63.3 8.1 12.9 24.7 4.5 78.2 4.5 78.2-12.1 42.9-5.9 62.6-5.9 62.6-2.7 17.5-11.2 79.7-10.1 112.5 0 0 77 26.6 166 6.1 0 0-22.7-112.8-.7-175.9 0 0-1.9-20.5 15.6-61.2 0 0-28.9-5.7-50.1-15.8-5.8-2.8-10.2-1.1-10.2-1.1.5-4.3-2-2.1-2-2.1Z"
      transform="translate(2)"
    />
    <path
      className="cls-46"
      d="M762.9 486.1a60.53 60.53 0 0 1 8.2-17.2c.4-.6 1.3 0 .9.5a60.4 60.4 0 0 0-8.1 17 .52.52 0 0 1-.7.3.71.71 0 0 1-.3-.6ZM747 557.2a137.5 137.5 0 0 1 16.2 27.7c.3.6-.6 1.2-.9.5a132.21 132.21 0 0 0-16.2-27.7c-.4-.6.5-1.1.9-.5Z"
      transform="translate(2)"
    />
    <path
      className="cls-9"
      d="m677.3 386.1-4.9 9.6-16.8 3.3s42.1 12.2 79.4 14.2l-19-10.6a26.15 26.15 0 0 1 1.6-12.4Z"
      transform="translate(2)"
    />
    <path
      className="cls-9"
      d="M609.1 403.8c-17.7 3-26.9 27.6-30.4 43.3-19 83.4-18 153 6.2 160.9 20.6 6.7 66.1-57.7 89-110.2 1.3-3 2.7-6 4.3-8.9a106.81 106.81 0 0 1 9.2-13.8c7.5-10.2-1-16.2 3.8-34 3.7-13.6 12-23.5 7.8-31.6a19.12 19.12 0 0 1-1.6-3.2c-2.2-6.9 3-12.9.2-16.3-.6-.7-1.2-.9-1.5-1.8-.8-2 .9-3.6.5-5.6s-3-3-3.8-3.2c-6.4-1.6-23.7 23.5-28 54-2.1 14.9 4.3 19.3 0 30.8-12.8 34.3-57 80.4-57 80.4 3.2-19.7 5.8-62.7 5.8-62.7 9.6-55-4.5-78.1-4.5-78.1Z"
      transform="translate(2)"
    />
    <path
      className="cls-9"
      d="M777.2 426.1c6.5 1.4 17.2 9.5 19.2 18.1 9.2 40.1 7.8 53.6-1.6 89.6-6.4 24.3-11.6 35-17.6 57.2-5.6 20.6-8.7 34.9-18.7 37.1-12.5 2.7-31.3-21.7-46.7-73.3-2.6-8.7-13.9-37.3-21.2-63.4-1.8-6.6-3.2-4.6-4.6-8-11.1-26.9 12.3-65.2 11-75.1-.7-5.4-2.2-12.6-.2-22.4.3-1.5 2.8-3.4 4.3-3.4 2.7 0 3.2 3.2 3.2 6.1 0 0 2.8-3.7 5.6-2.8s2.2 12 2.2 12c-.8 12.5 1.6 26 2.3 38.5.7 11.7-7.6 28.8-4.8 42.3 3.1 15.2 30.8 68.5 36.4 78.2 0 0 4-18.8 9-41.6 2.7-12.6 7.9-28 7.9-28-1.7-28.8 14.3-61.1 14.3-61.1Z"
      transform="translate(2)"
    />
    <path
      className="cls-46"
      d="M711.7 394.7a27.28 27.28 0 0 0-.3-4.1c-.1-1.1-.1-2.7-.9-3.6s-2.1-.6-3.1-.2a5.09 5.09 0 0 0-2.5 2.1c-.4.6-1.3 0-.9-.5a6.65 6.65 0 0 1 3-2.5c1.2-.5 2.8-.8 3.9.1s1.3 2.4 1.5 3.8c.2 1.7.3 3.4.4 5.1a.47.47 0 0 1-.5.5c-.3-.2-.6-.4-.6-.7Z"
      transform="translate(2)"
    />
    <path
      className="cls-46"
      d="M703.8 388.5c0-1.4.1-3.1-.8-4.3a2.62 2.62 0 0 0-3.1-.6c-1.8.9-2.8 3-3.3 4.9a.52.52 0 0 1-1-.3 9.51 9.51 0 0 1 3.2-5.1 3.77 3.77 0 0 1 5.2.7l.1.1a8.94 8.94 0 0 1 .7 4.6.56.56 0 0 1-.6.5.7.7 0 0 1-.4-.5ZM696 405.8c4.5 1.3 3.2 6.7 2.3 10-1.5 5.1-3.1 10.2-4.9 15.2-.8 2.4-1.8 4.8-2.5 7.3a32.41 32.41 0 0 0-.6 8.2 85.6 85.6 0 0 1-.8 15.2 70.79 70.79 0 0 1-4.7 16.3c-.3.6-1.2.1-.9-.5a67.76 67.76 0 0 0 5.5-28.1c0-2.4-.2-4.9-.1-7.3a24.16 24.16 0 0 1 1.3-6.6c1.6-4.6 3.2-9.2 4.7-13.9.8-2.6 1.6-5.2 2.3-7.8.6-2.4 1-6.1-2.1-7a.52.52 0 0 1-.3-.7c.3-.2.6-.4.8-.3Z"
      transform="translate(2)"
    />
    <path
      className="cls-46"
      d="M695.6 388.4c-.5-1.9.2-3.8-.3-5.6a3.82 3.82 0 0 0-4.5-2.3c-1.8.5-3.2 2.1-4.4 3.4s-2.7 3.1-3.9 4.7c-.4.5-1.3 0-.9-.5 1.4-1.8 2.8-3.6 4.4-5.3s3-3.1 5.2-3.5a5.33 5.33 0 0 1 4.9 2.3c1.1 2 0 4.3.6 6.4a.44.44 0 0 1-.4.6.48.48 0 0 1-.7-.2Z"
      transform="translate(2)"
    />
    <g
      style={{
        opacity: 0.3,
      }}
    >
      <path
        d="M704.9 388.4a46 46 0 0 0 .2 9.8c.5 3.1 1.3 6.1 1.8 9.3a78 78 0 0 1 .8 18.7.55.55 0 0 1-1.1 0 83.33 83.33 0 0 0-.9-19.3c-.5-3-1.4-6-1.8-9a49.12 49.12 0 0 1-.1-9.4c.1-.8 1.2-.8 1.1-.1Z"
        transform="translate(2)"
        style={{
          fill: "#9e6352",
        }}
      />
    </g>
    <path
      className="cls-46"
      d="M696.3 388.1c3 3.2 1.9 7.9 1 11.7A65.45 65.45 0 0 1 693 412c-3.7 8-8.2 15.8-9.8 24.5-.1.7-1.1.4-1-.3 1.5-8 5.3-15.2 8.8-22.5a68.32 68.32 0 0 0 4.6-11.6 42.59 42.59 0 0 0 1.5-6.9 7.75 7.75 0 0 0-1.6-6.4c-.4-.5.4-1.2.8-.7Z"
      transform="translate(2)"
    />
    <path
      className="cls-46"
      d="M695.7 389.3c-4.2-3.4-9.3 15.6-10.3 18a88.19 88.19 0 0 1-5.1 9.6 32 32 0 0 0-4 11.6c-.1.7-1.1.4-1-.3a33.44 33.44 0 0 1 4.5-12.6c1.1-1.9 2.3-3.7 3.3-5.7a60.7 60.7 0 0 0 2.4-5.9c1-3 5.3-20 11-15.4.5.3-.3 1.1-.8.7Z"
      transform="translate(2)"
    />
    <path
      className="cls-47"
      d="M609.1 403.8s-22.2-9.4-52 90.1c0 0 30.7 15.7 56.6 11.5s24.1-48.4 24.1-48.4ZM777.2 426.1s40.5 4.7 23.5 98.2c0 0-33.4-17.4-45-9s-13.9-9.2-13.9-9.2l14.9-56.3Z"
      transform="translate(2)"
    />
    <path
      className="cls-50"
      d="M681.6 388.8s-15.9 27.2-16.9 45.3M712.2 395.6s-.5 20.3 1.8 33.2M607.7 544.7s-15.4 8.2-19.5 22.4M746.1 556.9s8.2 13.5 11.5 28.8"
      transform="translate(2)"
    />
    <path
      className="cls-51"
      d="M709.5 580s-24.3 48.5-62.7 46.9M724 623.3s-44.4 17.4-59.3 15.8M756.1 477.6s1.8 9.7-.4 37.7"
      transform="translate(2)"
    />
    <ellipse
      className="cls-52"
      cx={677.61}
      cy={332.61}
      rx={21.7}
      ry={16.3}
      transform="rotate(-76.82 678.616 331.352)"
    />
    <ellipse
      className="cls-52"
      cx={746.78}
      cy={362.51}
      rx={21.7}
      ry={16.3}
      transform="rotate(-47.44 747.77 360.233)"
    />
    <path
      className="cls-9"
      d="m757.1 348.4-.7-.4 9.2-12.2c15.2-21.6 3.2-43.6-14.9-53.9-16.5-9.4-35.7-11.8-49.5 7.7a47.09 47.09 0 0 0-5.2 9.3l-5.1 11.6-.3-.2a8.54 8.54 0 0 0-8.5 14.8l.5.3c-7.8 18-8.5 42.4 11.9 54 21.7 12.3 41.6-.9 53.2-16.8l.9.6a8.56 8.56 0 0 0 11.5-3.6 8.48 8.48 0 0 0-3-11.2Z"
      transform="translate(2)"
    />
    <path
      d="M716.2 342.9c-1.2 1.2-2.4 2.4-3.6 3.5a29.49 29.49 0 0 0-2.5 2.5 2.32 2.32 0 0 0-.6 2.1 4.1 4.1 0 0 0 2 2.1 4.49 4.49 0 0 0 4.2-.3c.5-.2 0-1-.4-.7a3.64 3.64 0 0 1-4-.1c-.7-.5-1.2-1.2-.7-2.1a8.48 8.48 0 0 1 2.4-2.6c1.3-1.2 2.7-2.5 3.9-3.8.3-.4-.3-1.1-.7-.6Z"
      transform="translate(2)"
      style={{
        fill: "#e58c7a",
      }}
    />
    <path
      className="cls-52"
      d="M719.5 318.9c1.2-1 .9-2-1-3.5a17.58 17.58 0 0 0-6.6-2.8c-4.8-.9-8.6 1.9-7.1 1.8 2.5-.1 4.5.1 9 1.8 2.5 1 4.9 3.4 5.7 2.7ZM735.1 327.9c.3-1.6 1.3-1.8 3.5-1a17.28 17.28 0 0 1 5.8 4.2c3.2 3.7 2.9 8.3 2.1 7-1.2-2.2-2.4-3.8-6.2-6.8-2.1-1.6-5.4-2.3-5.2-3.4Z"
      transform="translate(2)"
    />
    <path
      className="cls-54"
      d="M757.3 354.1a6.07 6.07 0 0 0-3.2 1.3 6.91 6.91 0 0 0-2.1 3.2c-.2.5.5.6.7.2a7.5 7.5 0 0 1 1.8-2.8 5.36 5.36 0 0 1 2.7-1.1c.6-.1.6-.9.1-.8Z"
      transform="translate(2)"
    />
    <path
      className="cls-54"
      d="M754.1 356.3a2.19 2.19 0 0 1 .5.3l.1.1.2.2.1.1c0 .1.1.1.1.2v.1l.1.2v.7l-.1.2-.1.2a.1.1 0 0 1-.1.1l-.2.2-.1.1c.1-.1 0 0-.1 0s-.1.1-.2.1h-.2a.41.41 0 1 0 .2.8 2.63 2.63 0 0 0 1.6-1.5 2 2 0 0 0-.4-2.1 3.39 3.39 0 0 0-1.4-.9c-.2-.1-.4.1-.5.3s.1.4.3.5ZM684.8 313.5a4.81 4.81 0 0 1 .4 2.9 6.1 6.1 0 0 1-1.5 3c-.3.4.2.9.5.5a8.39 8.39 0 0 0 1.7-3.4 5.7 5.7 0 0 0-.5-3.4c-.1-.4-.8-.1-.6.4Z"
      transform="translate(2)"
    />
    <path
      className="cls-54"
      d="M685.7 316.5a2.56 2.56 0 0 0-2.5-.6 2.32 2.32 0 0 0-1.4 1.5 4.87 4.87 0 0 0-.1 1.2.55.55 0 0 0 .5.3.55.55 0 0 0 .3-.5V317.8l.1-.2v-.2c0-.1.1-.1.1-.2v-.1l.3-.3.1-.1.2-.1h.8l.3.1h.2a2.09 2.09 0 0 1 .6.4.45.45 0 0 0 .5 0 .63.63 0 0 0 0-.6Z"
      transform="translate(2)"
    />
    <path
      className="cls-21"
      d="M704.7 363.2c-4.8-2.7-6.7-6.4-6.8-8.6a.46.46 0 0 1 .4-.5.37.37 0 0 1 .3.1s5 3.3 8.3 5.2 8.8 4.5 8.8 4.5c.3.2.4.4.1.6-1.9 1-6 1.6-11.1-1.3Z"
      transform="translate(2)"
    />
    <path
      className="cls-55"
      d="M711 333.2a12 12 0 0 0-9-4.3c-.3 0-.4-.3-.4-.5a.43.43 0 0 1 .4-.4 12.82 12.82 0 0 1 9.6 4.6c.4.4-.3 1-.6.6ZM736.5 350.6a12.09 12.09 0 0 0-7.3-6.7.48.48 0 0 1-.2-.6.55.55 0 0 1 .5-.3 12.92 12.92 0 0 1 7.8 7.2c.2.5-.6 1-.8.4Z"
      transform="translate(2)"
    />
    <path
      className="cls-52"
      d="M776.6 334.2a49 49 0 0 1-.2-15.3c.8-6.4 2.1-12.8 2.3-19.3.2-7.9-1.3-15.2-6.8-20.2-7.2-6.6-14.7-13-26-6.9a10.9 10.9 0 0 0-4.3-9c-8.2-6-22.9-10.4-35.7.8-4.9 4.3-8.9 9.3-13.2 14.2-4 4.5-8.1 8.7-13.3 11.6-4.7 2.6-7.4 7-8.9 12.3a40.35 40.35 0 0 0-.5 18.6 32.66 32.66 0 0 1 .3 10.8l4.6 2.1c-2.5-3.5-2.4-7.5-1.3-11.8 1.3-4.7 3.3-8.8 8-10.7a5.22 5.22 0 0 1 5 .1l2.3 1 1.2.5c3.6.8 6.4-.9 8.8-3.7 3.3-1.5 5.5-8.5 5.5-8.5 2.2-4 4.3-8 6.7-11.8 4.7-7.3 11-8.3 17.3-6.7a50.23 50.23 0 0 1 20.7 11.4c5.8 5.1 7.5 10.5 4.3 18.4-1.7 4.1-3.5 8.2-5.3 12.3l-1.2 3.6a17.51 17.51 0 0 0-1.8 5.3c-1 5.3.9 8.8 5.8 11.1a15.05 15.05 0 0 1 1.7 1c.2.1.3.3.5.4a1.79 1.79 0 0 0 .7.5c.4.2.9.2 1.4-.5l-3.5-2.1c-3.8-1.8-5.5-4.5-5.1-8.2a18.85 18.85 0 0 1 2.8-6.1 5.28 5.28 0 0 0 0 3.6c-.5 3.7.6 6.6 3.4 8.6l4.1 1.9c2.7 2 3.9 6.4 2.4 10.6-1.7 4.7-4.1 8.8-8.5 11.3a10.09 10.09 0 0 1-1.5.7l-2.3.6 4.3 2a44.61 44.61 0 0 1 10.5-8.4 37.19 37.19 0 0 0 9-7.8c4.5-5.3 7.2-11.3 5.8-18.3Zm-30.1 1.2a2.92 2.92 0 0 1 .2-.9Z"
      transform="translate(2)"
    />
    <path
      className="cls-9"
      d="M759.8 350.9s4.5 10.8-7.1 13.4l5.5-7.9Z"
      transform="translate(2)"
    />
    <path
      className="cls-56"
      d="M601 887s11.3 50.6 31 58.1M678.2 715.9s-4.9 24.5 0 32"
      transform="translate(2)"
    />
  </svg>
  </StyledBackgroundWrapper>
  )
}

export default SvgRelationshipTwoA